import React, { useEffect, useRef } from "react";
import { AD_CLIENT } from "@/lib/ads";

/**
 * Google AdSense slot. Returns `null` when `client` or `slot` is missing —
 * no placeholder, no layout reservation. Every slot uses the same AdSense
 * publisher id but its own 10-digit ad-slot id.
 */
const AdSlot = ({
  client = AD_CLIENT,
  slot,
  format = "auto",
  responsive = true,
  layout,        // e.g. "in-article" or "in-feed"
  layoutKey,     // required for "in-feed" units (from AdSense dashboard)
  testId,
  className = "",
}) => {
  const insRef = useRef(null);

  useEffect(() => {
    if (!client || !slot) return;
    try {
      // eslint-disable-next-line no-unused-expressions
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // script not ready yet / already pushed — ignore
    }
  }, [client, slot]);

  if (!client || !slot) return null;

  return (
    <div className={className} data-testid={testId}>
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: "block", width: "100%", height: "100%" }}
        data-ad-client={client}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive ? "true" : "false"}
        {...(layout ? { "data-ad-layout": layout } : {})}
        {...(layoutKey ? { "data-ad-layout-key": layoutKey } : {})}
      />
    </div>
  );
};

export default AdSlot;
